/**
 * 运动幅度选择器（仅当模型 enableMotionIntensity 时显示）
 */

import type { MotionIntensity } from '../services/videoApi';

interface VideoMotionIntensitySelectorProps {
  value: MotionIntensity | undefined;
  onChange: (value: MotionIntensity | undefined) => void;
}

const OPTIONS: Array<{ id: MotionIntensity; label: string; description: string }> = [
  { id: 'low', label: '低', description: '画面变化轻微' },
  { id: 'medium', label: '中', description: '中等变化幅度' },
  { id: 'high', label: '高', description: '动态明显' },
];

export function VideoMotionIntensitySelector({
  value,
  onChange,
}: VideoMotionIntensitySelectorProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-light-text">运动幅度</span>
        {value && (
          <button
            type="button"
            className="text-xs text-light-muted hover:text-accent-blue"
            onClick={() => onChange(undefined)}
          >
            清除
          </button>
        )}
      </div>
      <div className="grid grid-cols-3 gap-2">
        {OPTIONS.map((opt) => {
          const isActive = opt.id === value;
          return (
            <button
              key={opt.id}
              type="button"
              onClick={() => onChange(isActive ? undefined : opt.id)}
              className={`px-2 py-2 rounded-lg border text-sm transition-all ${
                isActive
                  ? 'border-accent-blue bg-accent-blue text-white shadow-md'
                  : 'border-light-border bg-white text-light-secondary hover:border-accent-blue hover:text-accent-blue'
              }`}
              title={opt.description}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
